module.exports = __webpack_public_path__ + "img/flaminiaGiorda@2x.841d234d.jpg";